var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgULogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 693,
    viewBox: "0 0 574 693",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M573.905 7.80959V407.012C573.905 413.846 572.929 480.215 539.738 546.584C491.917 640.286 403.095 692.988 286.94 692.988C170.785 692.988 81.0119 641.25 34.1546 546.584C0.963979 480.215 0 413.846 0 407.012V7.80959C0 3.90481 3.90479 0 8.78577 0H564.155C570 0 573.905 3.90481 573.905 7.80959ZM444.095 406.024V117.119H129.809V407C129.809 407 130.786 450.917 152.262 491.917C178.619 541.69 222.536 566.095 286.952 566.095C351.369 566.095 395.298 541.69 421.643 491.917C443.119 450.929 444.095 407 444.095 406.024Z",
    fill: "#EAF0F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgULogo);
export default __webpack_public_path__ + "static/media/uLogo.f8f7c14405fc8f6d9d14c2336608eccc.svg";
export { ForwardRef as ReactComponent };